module.exports = __webpack_public_path__ + "static/media/room2red.71736a1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/bridging-the-gap/room2red.png
// module id = 360
// module chunks = 0